module.exports = ".sticky_table_wrapper {\r\n    overflow-y: scroll;\r\n    height: 35vh;\r\n  }"


//////////////////
// WEBPACK FOOTER
// ./src/app/a2103-yoyaku-register/show-yoyaku-createria.component.css
// module id = ./src/app/a2103-yoyaku-register/show-yoyaku-createria.component.css
// module chunks = main